// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"f0a54a80","684":"42bad904"}[chunkId] + ".chunk.js";
};